// 环境配置
const env = process.env.NODE_ENV || 'development'

// 接口地址配置
const API_CONFIG = {
  development: {
    baseURL: 'https://wan.f.yizuo.ltd',
    timeout: 10000,
    WECHAT_APPID: 'wx6a369949e658661b'
  },
  test: {
    baseURL: 'https://wan.f.yizuo.ltd',
    timeout: 10000,
    WECHAT_APPID: 'wx6a369949e658661b'
  },
  // production: {
  //   baseURL: 'https://new.wdianmilk.com', // 万点正式
  //   timeout: 10000,
  //   WECHAT_APPID: 'wxad9bbea518de321b'
  // }
  // production: {
  //   baseURL: 'https://yxd.wdianmilk.com', //优先订正式
  //   timeout: 10000,
  //   WECHAT_APPID: 'wx17f0ed94b93281ca'
  // }
  // production: {
  //   baseURL: 'https://ljxy.wdianmilk.com', //冷江正式
  //   timeout: 10000,
  //   WECHAT_APPID: 'wx7cfdee114cbf61ee'
  // }
  // production: {
  //   baseURL: 'https://dere.wdianmilk.com', //dere正式
  //   timeout: 10000,
  //   WECHAT_APPID: 'wx064db9ffab4911b8'
  // }
  production: {
    baseURL: 'https://hhzj.wdianmilk.com', //怀化正式
    timeout: 10000,
    WECHAT_APPID: 'wx5e2bdaf73628cd8f'
  }

}

// 导出当前环境的配置
export const currentConfig = API_CONFIG[env] || API_CONFIG.development

// 导出所有配置
export default API_CONFIG 

// 导出微信appid 测试环境：wx6a369949e658661b 生产环境：wxad9bbea518de321b
export const WECHAT_APPID = currentConfig.WECHAT_APPID